import React from "react";
import { Outlet } from "react-router-dom";
import Zenkleus from "../assets/Zenkleus.png";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { SnackbarProvider } from "notistack";

const RootLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("token"));
  return (
    <div className="root-layout bg-[#fffffff] sm:min-h-[100vh] sm:min-w-[750px]">
      {!location.pathname.includes("take-quiz/quiz") && (
        <header>
          <div className="flex my-5">
            <h1
              className="sm:ml-0 text-5xl font-extrabold cursor-pointer"
              onClick={() => navigate("/")}
            >
              Skoolbod Quiz
            </h1>
          </div>
          {user ? (
            <div className="flex gap-2 mt-2">
              <Button
                onClick={() => navigate("/add-question")}
                variant={
                  location.pathname === "/add-question"
                    ? "contained"
                    : "outlined"
                }
                size="small"
              >
                Upload Questions
              </Button>
              <Button
                className=""
                onClick={() => navigate("/my-quiz")}
                variant={
                  location.pathname === "/my-quiz" ? "contained" : "outlined"
                }
              >
                My Quizzes
              </Button>
              <Button
                variant={
                  location.pathname === "/questions" ? "contained" : "outlined"
                }
                onClick={() => navigate("/questions")}
              >
                Questions
              </Button>
              <Button
                onClick={() => {
                  localStorage.removeItem("userdata");
                  navigate("/login");
                }}
                variant="outlined"
              >
                Logout
              </Button>
            </div>
          ) : (
            <div className="flex gap-3 mt-3">
              <Button onClick={() => navigate("/login")} variant="outlined">
                Login
              </Button>
              <Button onClick={() => navigate("/sign-up")} variant="outlined">
                Register
              </Button>
            </div>
          )}
        </header>
      )}
      <main className="content">
        <SnackbarProvider />
        <Outlet />
      </main>
      <footer className="flex w-full items-center justify-center">
        <div className="flex flex-row items-center">
          <span className="font-black text-xl sm:text-3xl ml-6 sm:ml-20">
            Powered by:{" "}
          </span>
          <a
            target="_blank"
            href="https://zenkleus.com"
            style={{ cursor: "pointer" }}
          >
            <img
              className="max-md:w-[150px] w-[250px] object-contain "
              src={Zenkleus}
              alt="Zenkleus"
            />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default RootLayout;
